import React from "react";
import styles from "./index.module.scss";

export default ({ T, appStyles, onChange }) => (
  <div className={styles.ImageContainer} style={appStyles.Button}>
    {T("Upload Photo")}
    <input type="file" onChange={onChange} className={styles.ImageInput} />
  </div>
);
